<template>
  <div>
    <!-- SVG defs to control the gradient of the Classic Icons -->
    <svg aria-hidden="true" focusable="false" style="position:absolute;width:0;height:0;">
      <defs>
        <linearGradient
          id="reporting-widget-gradient"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="100%"
        >
          <stop offset="0%" stop-color="#8040A2" />
          <stop offset="100%" stop-color="#005EE0" />
        </linearGradient>
      </defs>
    </svg>
    <RWidgetSimple :class="{'locked': locked}">
      <template #header>
        <div>
          <span v-if="infoText">
            <CIcon
              v-c-tooltip="{
                content: infoText,
                color:'primary',
                placement:'top',
                boundaries: 'window'
              }"
              name="md-info"
              class="info-icon"
            />
          </span>
          <CIcon
            :name="locked ? classicIcon : duotoneIcon"
            :class="locked ? 'classic-icon' : 'duotone-icon'"
            size="3xl"
          />
        </div>
      </template>
      <template>
        <div class="content-wrap">
          <div class="widget-content">
            <div v-if="locked" class="locked">
              Contact <a href="mailto:help@rooof.com" target="_blank">help@rooof.com</a>
              to unlock this feature!
            </div>
            <div v-else>
              {{ text || 'No Data' }}
            </div>
          </div>

          <div class="title">
            <a v-if="titleIsLink && title.href" :href="title.href" target="_blank">
              {{ title.label }}
            </a>
            <CLink v-else-if="titleIsLink && title.to" :to="title.to">
              {{ title.label }}
            </CLink>
            <span v-else>
              {{ title }}
            </span>
          </div>
        </div>
      </template>
    </rwidgetsimple>
  </div>
</template>

<script>
/**
 * Simple widget to display top-level reporting stats.
 *
 * `title` prop can be a string (default) or object (external link).
 */
import { RWidgetSimple } from '@/components/widgets'

export default {
  name: 'ReportingWidget',
  components: {
    RWidgetSimple
  },
  props: {
    title: {
      type: [String, Object],
      default: ''
    },
    classicIcon: {
      type: String,
      default: ''
    },
    duotoneIcon: {
      type: String,
      default: ''
    },
    text: {
      type: [String, Number],
      default: 'No Data'
    },
    locked: {
      type: Boolean,
      default: false
    },
    infoText: {
      type: String,
      default: ''
    }
  },
  computed: {
    titleIsLink () {
      return typeof this.title === 'object'
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  color: $info;
}
.duotone-icon {
    color: $primary-base;
  }
// Controls the gradient fill for the Classic Icons
.classic-icon {
  fill: url(#reporting-widget-gradient);
  opacity: 0.4;
}
.header {
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 60px;
  position: relative;

  .info-icon {
    position: absolute;
    top: 6px;
    right: 6px;
    color: $gray-400;
  }
}
.widget-content {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 600;
  min-height: 2.6rem;

  .locked {
    font-size: 14px;
    font-weight: 500;
    opacity: 60%;
  }
}
//* This CSS controls the order of the title and content within the widget
.content-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}
/* default: title after content */
.content-wrap .title {
  order: 1;
}
.content-wrap .widget-content {
  order: 0;
}
/* when the widget is locked, show the title above the content */
.locked ::v-deep .content-wrap .title {
  order: -1;
}

</style>
